@if (visible()) {
<button
  type="button"
  class="event-role-chip"
  [disabled]="!canSwitch()"
  [attr.aria-haspopup]="canSwitch() ? 'dialog' : null"
  [attr.aria-label]="'event-access.chip.aria' | translate: { role: (fullLabelKey() | translate) }"
  (click)="openSheet()"
>
  <span class="chip-label">{{ labelKey() | translate }}</span>
  @if (canSwitch()) {
  <ion-icon class="chip-caret" name="chevron-down-outline" aria-hidden="true" />
  }
</button>
}
